import { api } from "@/lib/api";
import { toast } from "sonner";
import { ExpedienteItem, Certificado } from "./Tramite";

const gs = (n) => (n == null ? "—" : `Gs. ${Number(n).toLocaleString("es-PY", { maximumFractionDigits: 0 })}`);
const NIVEL = { alto: "bg-red-50 text-red-800", medio: "bg-amber-50 text-amber-800" };

export function ExpAlertas({ i }) {
  const al = i.snc_exp?.alertas || [];
  return al.map((a, k) => <div key={k} className={`p-1 rounded font-semibold ${NIVEL[a.nivel] || ""}`} data-testid="inm-exp-alerta">SNC · {a.texto} <a href={a.link} target="_blank" rel="noreferrer" className="underline font-normal">ver en SNC</a></div>);
}

export default function Expedientes({ i, codigo, isAdmin, onReload }) {
  const e = i.snc_exp;
  const d = e?.datos;
  const actualizar = async () => { try { await api.post(`/inmuebles/cliente/${codigo}/expedientes`, null, { params: { clave: i.clave } }); toast.info("Consultando el SNC (1 pedido cada 2 s)…"); setTimeout(onReload, 6000); } catch (er) { toast.error(er?.response?.data?.detail || "No se pudo"); } };
  if (i.precision !== "exacta") return null;
  const urb = i.tipo_inmueble === "urbano" || !!d?.cuenta;
  return (
    <div className="p-2 rounded bg-slate-50 space-y-1 text-xs" data-testid="inm-expedientes">
      <div className="flex items-center gap-2 flex-wrap"><b>Expedientes SNC · {urb ? `cuenta corriente ${i.codigo_distrito_snc} ${d?.cuenta || i.snc?.cuenta || i.cuenta_catastral || "—"}` : `cuenta rural ${i.codigo_distrito_snc} padrón ${i.snc?.padron || "—"}`}</b>
        {e?.actualizado && <span className="text-slate-500">consultado {e.actualizado.slice(0, 10)}</span>}
        {isAdmin && <button onClick={actualizar} className="underline text-emerald-800" data-testid="inm-exp-actualizar">Actualizar expedientes</button>}
        {d?.link && <a href={d.link} target="_blank" rel="noreferrer" className="underline text-slate-600">consulta pública SNC</a>}
      </div>
      {!e && <p className="text-sky-700" data-testid="inm-exp-pendiente">consultando el SNC…</p>}
      {e?.error && <p className="text-amber-700" data-testid="inm-exp-error">{e.error}</p>}
      {d && <>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-1">
          <span data-testid="inm-exp-inscripcion">Inscripción: <b>{d.fecha_inscripcion || "—"}</b></span>
          <span data-testid="inm-exp-situacion">Situación: <b>{d.situacion || "—"}</b>{d.situacion === "A" ? " (activa)" : ""}</span>
          <span>Superficie SNC: <b>{urb ? (d.superficie_m2 != null ? `${Number(d.superficie_m2).toLocaleString("es-PY")} m²` : "sin dato") : `${d.hectareas} ha`}</b></span>
          <span data-testid="inm-exp-valor">Valor fiscal: <b>{gs(d.valor_fiscal_gs)}</b></span>
        </div>
        {d.propietarios?.length > 0 && <p>Titular SNC: {d.propietarios.map((p) => `${p.nombre}${p.documento ? ` (${p.documento})` : ""}`).join("; ")}</p>}
        {d.expedientes?.length ? <ul className="list-disc ml-4" data-testid="inm-exp-lista">{d.expedientes.map((x, k) => <ExpedienteItem key={k} x={x} codigo={codigo} clave={i.clave} />)}</ul> : <p className="text-slate-500">Sin expedientes en la {urb ? "cuenta corriente" : "cuenta rural"}.</p>}
        <Certificado i={i} codigo={codigo} isAdmin={isAdmin} onReload={onReload} />
        <ExpAlertas i={i} />
        <p className="text-slate-500">{d.fuente} · seguimiento de trámites hasta 14/01/2026 (legacy) · dato público orientativo; nunca sustituye el informe de condiciones de dominio.</p>
      </>}
    </div>
  );
}
